import { PageHero } from "@/components/sections/PageHero";
import { CTABand } from "@/components/sections/CTABand";
import { IMAGES } from "@/lib/site";

const posts = [
  { tag: "Coatings 101", title: "Choosing the Right Powder Chemistry for Outdoor Use", excerpt: "Not every polyester is weatherable. Here's how we pick between standard, super-durable, and fluoropolymer powders for exterior projects." },
  { tag: "Surface Prep", title: "When to Blast, When to Chemically Strip — and When to Do Both", excerpt: "Media blasting removes coating fast. Chemical stripping protects thin substrates. The right prep depends on substrate, coating history, and end-use." },
  { tag: "Program Work", title: "How OEMs Reduce Coating Bottlenecks with a Regional Partner", excerpt: "Consolidating coating volume with one facility cuts lead times, freight, and QC overhead. Here's what to look for in a partner." },
];

export default function Blog() {
  return (
    <div data-testid="blog-page">
      <PageHero
        eyebrow="Field Notes"
        title={<>Notes from<br /><span className="text-[#FF5722]">the floor.</span></>}
        subtitle="Practical writing for engineers, buyers, and builders — no filler, no fluff."
        image={IMAGES.welding}
      />

      <section className="section px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <article key={i} className="border border-white/10 p-8 hover:border-[#FF5722] transition-colors bg-[#0B0B0D]" data-testid={`blog-post-${i}`}>
              <div className="eyebrow mb-3">{p.tag}</div>
              <h3 className="font-display text-2xl md:text-3xl tracking-tight leading-tight">{p.title}</h3>
              <p className="text-zinc-400 mt-4 leading-relaxed">{p.excerpt}</p>
              <div className="mt-6 text-xs uppercase tracking-widest text-zinc-500">Coming soon</div>
            </article>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
